(() => {
  'use strict';
  const slot = document.querySelector('[data-kn-inquiry-slot]');
  if (!slot) return;
  const root = document.querySelector('[data-kn-contact]') || document.getElementById('kn-product-finder');
  if (!root) return;
  const fallback = root.querySelector('[data-kn-native-fields]') || root.querySelector('#kn-request-form');
  let shadow = null;
  let lastBrief = '';
  let desiredBrief = '';
  let submitted = false;
  let attempt = null;
  const trackedForms = new WeakSet();
  function track(name, details) {
    try {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') Promise.resolve(analytics.publish(name, {form_id: '1186586', method: 'shopify_forms', submission_id: attempt?.id || '', ...details})).catch(() => {});
    } catch (error) {}
  }
  function observeSubmission() {
    if (!attempt || submitted) return;
    const success = shadow.querySelector('[data-current-step="success"]');
    if (success) {
      submitted = true;
      document.dispatchEvent(new CustomEvent('kn:inquiry-success'));
      track('kn:contact_submitted', {confirmed: true, status: 'success'});
      return;
    }
    const invalid = shadow.querySelector('[aria-invalid="true"]');
    const errors = Array.from(shadow.querySelectorAll('[role="alert"],[class*="errorMessage"],[class*="ErrorMessage"]')).some(element => element.textContent.trim());
    if ((invalid || errors) && !attempt.failed) {
      attempt.failed = true;
      track('kn:contact_submit_error', {status: 'error', error_code: 'form_rejected'});
    }
  }
  let observer = null;
  let ticks = 0;
  let resizeObserver = null;
  let observedAction = null;
  function alignActions() {
    if (!shadow) return;
    const actions = slot.querySelector('[data-kn-form-whatsapp]');
    const form = shadow.querySelector('form');
    const target = form && (form.querySelector('button[type="submit"],input[type="submit"]') || form);
    if (!actions || !target) return;
    if (target !== observedAction) {
      if (resizeObserver) resizeObserver.disconnect();
      observedAction = target;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(alignActions);
        resizeObserver.observe(target);
      }
    }
    const width = target.getBoundingClientRect().width;
    if (width >= 48) actions.style.setProperty('--kn-form-action-width', width + 'px');
  }
  function syncBrief() {
    if (!shadow || submitted) return;
    const field = shadow.querySelector('textarea[name="custom#product_brief"]');
    if (!field) return;
    const body = root.querySelector('#ContactForm-body');
    const details = root.querySelector('[data-kn-reference-field="details"]');
    const brief = body ? [body.value, details && details.value].filter(Boolean).join('\n\n') : desiredBrief;
    if (!brief || brief === lastBrief) return;
    if (!field.value || field.value === lastBrief) {
      Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set.call(field,brief);
      field.dispatchEvent(new Event('input',{bubbles:true}));
      field.dispatchEvent(new Event('change',{bubbles:true}));
      lastBrief=brief;
    }
  }
  function connect() {
    const container = document.querySelector('[data-forms-id="forms-root-1186586"]');
    const embed = container && container.querySelector('shopify-forms-embed');
    const current = embed && embed.shadowRoot;
    if (!current || !current.querySelector('form')) return false;
    if (!slot.contains(container)) {
      const previousSection = container.closest('.shopify-section');
      slot.appendChild(container);
      if (previousSection && !previousSection.contains(slot)) previousSection.hidden=true;
    }
    if (shadow !== current) {
      shadow=current;
      if(observer)observer.disconnect();
      observer=new MutationObserver(() => {
        observeSubmission();
        syncBrief();
        alignActions();
      });
      observer.observe(shadow,{childList:true,subtree:true,attributes:true,attributeFilter:['data-current-step','aria-invalid']});
    }
    const currentForm = current.querySelector('form');
    if (currentForm && !trackedForms.has(currentForm)) {
      trackedForms.add(currentForm);
      currentForm.addEventListener('submit', () => {
        if (submitted) return;
        attempt = {id: typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2), failed: false};
        track('kn:contact_submit_attempt', {status: 'attempt'});
      }, true);
    }
    if (fallback) fallback.hidden=true;
    slot.hidden=false;
    const hint=slot.querySelector('[data-kn-form-loading]');
    if(hint)hint.hidden=true;
    const whatsapp=root.querySelector('[data-kn-contact-whatsapp],#kn-request-whatsapp');
    const actions=slot.querySelector('[data-kn-form-whatsapp]');
    if(whatsapp && actions && !actions.contains(whatsapp)) actions.appendChild(whatsapp);
    if(actions)slot.appendChild(actions);
    alignActions();
    syncBrief();
    return true;
  }
  document.addEventListener('kn:brief-updated',event=>{desiredBrief=String(event.detail?.brief||'');syncBrief();});
  document.addEventListener('kn:reference-updated',syncBrief);
  const timer=window.setInterval(()=>{ticks++;if(connect() || ticks>=60)window.clearInterval(timer);},500);
  connect();
})();

